import { render, staticRenderFns } from "./EditorView.vue?vue&type=template&id=bce0d912&scoped=true&"
import script from "./EditorView.vue?vue&type=script&lang=js&"
export * from "./EditorView.vue?vue&type=script&lang=js&"
import style0 from "./EditorView.vue?vue&type=style&index=0&id=bce0d912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce0d912",
  null
  
)

export default component.exports